import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class FrontUserTaskService {
  constructor(private http: HttpClient, private api: AppConfig) {}

  addFrontUserTask(body: object) {
    return this.http.post(this.api.baseUrl + '/frontUserTask/addFrontUserTask', body, this.api.jsonTokenHeaders);
  }

  deleteFrontUserTask(id: number) {
    return this.http.delete(this.api.baseUrl + '/frontUserTask/deleteFrontUserTask?id=' + id, this.api.jsonTokenHeaders);
  }

  verify(frontUserTaskId: number, sendCertificate: boolean) {
    return this.http.get(this.api.baseUrl + '/frontUserTask/verify?frontUserTaskId=' + frontUserTaskId + '&sendCertificate=' + sendCertificate, this.api.jsonTokenHeaders);
  }

  reject(frontUserTaskId: number, adminComment: string) {
    return this.http.post(this.api.baseUrl + '/frontUserTask/reject',
      {frontUserTaskId, adminComment}, this.api.jsonTokenHeaders);
  }
}
